import { render, staticRenderFns } from "./ListEvaluations.vue?vue&type=template&id=2392f00c&scoped=true"
import script from "./ListEvaluations.vue?vue&type=script&lang=js"
export * from "./ListEvaluations.vue?vue&type=script&lang=js"
import style0 from "./ListEvaluations.vue?vue&type=style&index=0&id=2392f00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2392f00c",
  null
  
)

export default component.exports